/**
 *
 * @param {HTMLSelectElement} select
 */
export function showSelectError(select) {
  select.classList.add('error')
  const sibling = select.nextElementSibling
  if (sibling && sibling.classList.contains('select-error-container')) {
    const message = select.dataset.errorMessage || ''
    sibling.innerHTML = message
  }
}

/**
 * Must have structure below:

  <div class="input-container">
    <input
      data-error-message="Please Enter Your Full Name"
      data-test="name"
      id="name"
      name="name"
      placeholder="Full Name"
      required
      type="text"
    />
    <div class="input-error-container"></div>
  </div>

 */
